<div class="form-modal">
    <div class="form-modal__body">

        <!-- <a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
          aria-label="Close consent form">
          <img src="./assets/img/icons-svg/close-icon.svg">
      </a> -->
        <div class="img-wrapper">
            <div class="clearfix"></div>
            <div class="title-wrapper">
                <h1>Share Assessment Alerts with Counselors</h1>
            </div>
        </div>
        <div class="form-wrapper">
            <p>I give permission for Welltrack to share information I have provided on the Welltrack tool to my school's
                Counseling Center.
                I understand that by sharing my information, I may be contacted by my school's Counseling Center to
                explore my needs further.
                I understand that I may revoke this permission at any time by going to the user settings page and
                choosing to remove this permission.</p>

            <div class="app-c-form-group">
                <select
                    class="app-c-form-control"
                    name="surveyconfirm"
                    [(ngModel)]="surveyconfirm"
                    (change)="showOptions($event)">
                    <option value="">-- Select --</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
            </div>
            <button type="submit" tabindex="0" class="app-c-btn app-c-btn--primary app-c-btn--curve" [disabled]="!surveyconfirm"
                (click)="consentSave()">Submit</button>
        </div>
    </div>
</div>
